export const lectoresColumns = [
  { field: "id", headerName: "ID", width: 20 },
  {
    field: "nombre",
    headerName: "Nombre",
    width: 255,
  },
  {
    field: "telefono",
    headerName: "Telefono",
    width: 255,
  },
  {
    field: "direccion",
    headerName: "Direccion",
    width: 255,
  }
];